module.exports = __webpack_public_path__ + "static/img/vroot_0120.2c65e96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vroot_0120.jpg
// module id = qGG+
// module chunks = 0